
import Vue from 'vue'
import { QInput } from 'quasar';

export default Vue.extend({
    components: {  QInput },

    data() {
        return {
            comment: ''
        }
    }
})
